import { Box, Typography } from "@mui/material";
import "./orderSummaryCard.scss";

interface IOrderSummaryCardProps {
	createdBy: string;
	ordNumber: number;
}

const OrderSummaryCard = ({ createdBy, ordNumber }: IOrderSummaryCardProps) => {
	return (
		<Box className="orderSummaryCard">
			<Typography variant="body2" className="orderSummaryCardCreatedByText">
				Created By {createdBy}
			</Typography>
			<Typography variant="h6" className="orderSummaryCardOrderNumberText">
				ORD # {ordNumber}
			</Typography>
		</Box>
	);
};

export default OrderSummaryCard;
